import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { canUseLivy } from './access';
import { LivyDrawer } from './LivyDrawer';
import { LivyAvatar } from './LivyAvatar';
import { LivyCommandPalette, useCommandPalette } from './LivyCommandPalette';

/**
 * Mounts everything that should exist on every authenticated page: the support button that opens
 * the drawer, and Cmd-K. Admin-gated for the initial rollout, every Livy surface ships behind
 * LivableAdmin/LivableSuperAdmin and un-gates progressively.
 */
export function LivyLauncher() {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const enabled = canUseLivy();
  const _useCommandPalette = useCommandPalette(enabled),
    paletteOpen = _useCommandPalette.open,
    setPaletteOpen = _useCommandPalette.setOpen;
  if (!enabled) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Livy",
    placement: "left"
  }, /*#__PURE__*/React.createElement(Fab, {
    color: "primary",
    size: "medium",
    "aria-label": "Ask Livy",
    onClick: () => setOpen(true),
    sx: {
      position: 'fixed',
      right: 24,
      bottom: 24,
      zIndex: theme => theme.zIndex.drawer - 1,
      p: 0,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(LivyAvatar, {
    size: 48
  }))), /*#__PURE__*/React.createElement(LivyDrawer, {
    open: open,
    onClose: () => setOpen(false)
  }), /*#__PURE__*/React.createElement(LivyCommandPalette, {
    open: paletteOpen,
    onClose: () => setPaletteOpen(false)
  }));
}